import { Card, CardBody, CardHeader } from "reactstrap";
import { useAccess } from "../../../../utils/hooks/access";
import { OverviewProvider } from "../../components/Topbar/context";
import ConfigurationLoader from "../../configurationLoader";
import { FiltersProvider } from "../../filtersContext";
import { DateFiltersProvider } from "../../hooks/useDateFilters";
import { PayCodesProvider } from "../../reusedResourcesContext";
import Content from "./Content";
import Topbar from "./Topbar";

function Weekly() {
  const { hasAccess: canViewRates } = useAccess("canViewMyRates");

  return (
    <PayCodesProvider>
      <ConfigurationLoader>
        <FiltersProvider sessionKey="TIMESHEET_WEEKLY_HOME_FILTERS">
          <DateFiltersProvider>
            <OverviewProvider>
              <Card className="time-sheet px-0 m-0 h-100 position-static">
                <CardHeader>
                  <Topbar canViewRates={canViewRates} />
                </CardHeader>

                <CardBody className="p-0 d-flex flex-column">
                  <Content />
                </CardBody>
              </Card>
            </OverviewProvider>
          </DateFiltersProvider>
        </FiltersProvider>
      </ConfigurationLoader>
    </PayCodesProvider>
  );
}

export default Weekly;
